export class PartnerSubmissionYearMonthRequestDTO {
    yearMonth: Date;
    status: number[]
    statusNotIn: number[]

    constructor(data?: any) {
        this.yearMonth = data?.yearMonth ?? null;
        this.status = data?.status ?? [];
        this.statusNotIn = data?.statusNotIn ?? [];

    }
}
